import Vue from 'vue'
import currency from './currency'
import bankAccount from './bank-account'
import number from './number'
import plurals from './plurals'
import formatPhone from './format-phone'
import formatPrice from './format-price'
import plainText from './plain-text'
import filesize from './filesize'

const filters = {
    currency,
    bankAccount,
    number,
    plurals,
    formatPhone,
    formatPrice,
    plainText,
    filesize
}

Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key])
})

export default filters
